import { Dispatch, SetStateAction } from "react";

export interface IFormStateChangeHandler {
  key: string;
  value: string | boolean;
  formState: Object;
  setTouched: Dispatch<SetStateAction<boolean>>;
  formStateSetter: Dispatch<SetStateAction<any>>;
}

export const formStateChangeHandler = ({
  key,
  value,
  formState,
  setTouched,
  formStateSetter,
}: IFormStateChangeHandler) => {
  setTouched(true);
  formStateSetter({ ...formState, [key]: value });
};
